import React from "react";
import { Button, Icon, List, Modal } from "semantic-ui-react";
import styles from "./styles.module.css";

export interface DownloadItem {
	filename: string;
	sasUrl: string;
	description: string;
}

interface DataLayerDownloaderProps {
	open: boolean;
	downloads: DownloadItem[];
	onDownload: (item: DownloadItem) => void;
	onClose: () => void;
}

/**
 * Modal dialog presenting a list of data layer files for download.
 */
function DataLayerDownloader({ open, downloads, onDownload, onClose }: DataLayerDownloaderProps) {
	return (
		<Modal open={open} onClose={onClose} closeOnDimmerClick={true} closeOnEscape={true}>
			<Modal.Header>Download Data Layer Assets</Modal.Header>
			<Modal.Content>
				<List>
					{downloads.map((item) => (
						<List.Item key={item.filename} className={styles.downloaderItem}>
							<a onClick={() => onDownload(item)} className={styles.downloaderLink}>
								<Icon name="download" />
								{item.filename}
							</a>
							<span className={styles.downloaderDescription}>{item.description}</span>
						</List.Item>
					))}
				</List>
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={onClose}>Close</Button>
			</Modal.Actions>
		</Modal>
	);
}

export default DataLayerDownloader;
